import React, { useState } from 'react';

import { ServiceCatalogItem } from '@nile/types';
import { ToggleButton } from '@superops/ui-design-system';

function TaxToggleCell(props) {
  const { cell } = props;
  const { actions, editable } = cell?.column;
  const rowData: ServiceCatalogItem = cell?.row?.original;
  const isEditable = editable && rowData?.status !== 'INACTIVE';

  const [loading, setLoading] = useState(false);

  return (
    <div className="fx fg1" key={rowData?.itemId}>
      <ToggleButton
        value={rowData?.taxable}
        onChange={(checked) => {
          const inputObject = {
            itemId: rowData?.itemId,
            taxable: checked
          };

          if (!checked && rowData?.salesTax) {
            inputObject.salesTax = null;
          }

          if (actions?.save) {
            setLoading(true);
            actions
              .save(inputObject)
              .then(() => {
                setLoading(false);
              })
              .catch(() => {
                setLoading(false);
              });
          }
        }}
        locked={!isEditable || loading}
        size="small"
      />
    </div>
  );
}

export default TaxToggleCell;
